// import Button from "@/components/bricks/button/Button";
// import CloseSmallIcon from "../icons/CloseSmallIcon";

export const ComboBox = (props: {
  hasValue?: boolean;
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <>
      <div
        className={`c-combobox ${props.className ?? ""} ${
          props.hasValue ? "c-combobox-has-value" : ""
        }`}
      >
        {props.children}
        {/* <Button
          icon
          transparent
          color="primary"
          aria-label="Ryd"
          onClick={() => {}}
          className="flex-shrink-0"
        >
          <CloseSmallIcon />
        </Button> */}
      </div>
    </>
  );
};
